/**
 * @license
 * @copyright Copyright Motili Inc., 2026 All Rights Reserved
 */

export interface ContractorStep {
    number: number;
    title: string;
    route: string;
    optional?: boolean;
}

export const CONTRACTOR_STEPS: ContractorStep[] = [
    { number: 1, title: "Let's Get Started", route: 'getStarted' },
    { number: 2, title: 'Your Company', route: 'company' },
    {
        number: 3,
        title: 'Labor Information',
        route: 'laborInfo',
        optional: true,
    },
    { number: 4, title: 'Documents', route: 'documents' },
];
